import { render, staticRenderFns } from "./FRadioGroup.vue?vue&type=template&id=64a80f66&"
import script from "./FRadioGroup.vue?vue&type=script&lang=js&"
export * from "./FRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports